export default class LessThan {
  constructor() {
    'ngInject';

    this.require = 'ngModel';
    this.restrict = 'A';
  }

  link($scope, element, attrs, ctrl) {
    const compareTo = attrs.lessThan;

    $scope.$watch(attrs.lessThan, () => {
      ctrl.$validate();
    });

    ctrl.$validators.lessThan = (modelValue) => {
      const watchVal = $scope.$eval(compareTo);

      if (modelValue === undefined || watchVal === undefined) {
        return true;
      }

      return !(modelValue > watchVal);
    };
  }

  static directiveFactory() {
    'ngInject';

    return new LessThan();
  }
}



// WEBPACK FOOTER //
// ./common/directives/validation/less-than.js